// Utility functions for authentication and token management

/**
 * Clears localStorage items when user logs out or token expires
 */
export const clearLocalStorageItems = () => {
  const keys = ['token', 'redirectPath'];
  keys.forEach(key => {
    localStorage.removeItem(key);
  });
};

/**
 * Checks if a JWT token is expired
 * @param {Object} tokenClaims - The decoded token claims
 * @returns {boolean} - True if token is expired, false otherwise
 */
export const isTokenExpired = (tokenClaims) => {
  if (!tokenClaims || !tokenClaims.exp) {
    return true;
  }
  
  const currentTime = Date.now() / 1000; // Current time in seconds
  return tokenClaims.exp < currentTime;
};

/**
 * Logs token expiration information
 * @param {Object} tokenClaims - The decoded token claims
 */
export const logTokenStatus = (tokenClaims) => {
  if (!tokenClaims) {
    console.log("No token claims available");
    return;
  }
  
  const currentTime = Date.now() / 1000;
  const timeUntilExpiry = tokenClaims.exp - currentTime;
  
  if (timeUntilExpiry > 0) {
    console.log(`ID Token is still valid. Expires in ${Math.floor(timeUntilExpiry / 60)} minutes`);
  } else {
    console.log(`ID Token has expired ${Math.floor(Math.abs(timeUntilExpiry) / 60)} minutes ago`);
  }
};
